(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.hideStickyLogoDesktop = this.getAttribute('data-hide-sticky-logo-desktop') === 'true';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.dockDesktop = this.getAttribute('data-dock-desktop') === 'true';

      this._onStickyLogoDesktopMql = () => {
        if (this.isDocking()) {
          this.reset();
          this.measureDockBounds();
        } else {
          this.undock();
        }
        this.syncStickyLogoVisibility();
      };
      this._stickyLogoDesktopMql = window.matchMedia('(min-width: 990px)');
      this.measureDockBounds();
      this._stickyLogoDesktopMql.addEventListener('change', this._onStickyLogoDesktopMql);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    /**
     * Desktop dock mode: the floating header scrolls away naturally, then drops in as a flat bar
     * pinned to the top (`header-docked`, styled in base.css) and stays until the page is back at the top.
     */
    isDocking() {
      return this.dockDesktop && this._stickyLogoDesktopMql.matches;
    }

    /** Header's position in the page (not the viewport), so thresholds hold even if the page loads scrolled. */
    measureDockBounds() {
      if (this.header.classList.contains('header-docked')) return;
      const rect = this.header.getBoundingClientRect();
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      this.dockBounds = { top: rect.top + scrollY, bottom: rect.bottom + scrollY };
    }

    dock() {
      if (this.header.classList.contains('header-docked')) return;
      this.closeMenuDisclosure();
      this.header.classList.add('header-docked', 'scrolled-past-header');
      // Lets sticky page elements (e.g. article sidebars) sit below the docked bar.
      document.documentElement.style.setProperty('--header-docked-height', `${this.offsetHeight}px`);
    }

    undock() {
      if (!this.header.classList.contains('header-docked')) return;
      this.closeMenuDisclosure();
      this.header.classList.remove('header-docked', 'scrolled-past-header');
      document.documentElement.style.removeProperty('--header-docked-height');
    }

    /**
     * Theme setting: hide logo in sticky bar on desktop (990px+). Toggles the native `hidden` attribute
     * in sync with section scroll classes so it cannot be lost to CSS order/specificity.
     */
    syncStickyLogoVisibility() {
      if (!this.hideStickyLogoDesktop) {
        this.querySelectorAll('.header__heading').forEach((el) => el.removeAttribute('hidden'));
        return;
      }
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      const hideLogo = isDesktop && this.header.classList.contains('scrolled-past-header');
      this.querySelectorAll('.header__heading').forEach((el) => {
        if (hideLogo) el.setAttribute('hidden', '');
        else el.removeAttribute('hidden');
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._stickyLogoDesktopMql) {
        this._stickyLogoDesktopMql.removeEventListener('change', this._onStickyLogoDesktopMql);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        this.measureDockBounds();
        observer.disconnect();
        requestAnimationFrame(() => {
          this.onScrollHandler();
        });
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.syncStickyLogoVisibility();
        return;
      }

      if (this.isDocking()) {
        if (scrollTop > this.dockBounds.bottom) {
          this.dock();
        } else if (scrollTop <= this.dockBounds.top) {
          this.undock();
        }
        this.currentScrollTop = scrollTop;
        this.syncStickyLogoVisibility();
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      this.syncStickyLogoVisibility();
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
